import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { AppConfig } from '../constants/app-config';

const DEFAULT_TIMEOUT = 60000;

@Injectable()
export class HttpInterceptorCustom implements HttpInterceptor {
  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      timeout(AppConfig.httpTimeout ?? DEFAULT_TIMEOUT),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
}
